var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.355,
    height: 17.748,
    viewBox: "0 0 25.355 17.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_152",
    "data-name": "Rectangle 152",
    width: 25.355,
    height: 17.748,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M1.521,0A1.529,1.529,0,0,0,0,1.521V11.663a1.529,1.529,0,0,0,1.521,1.521H14.294a5.576,5.576,0,1,0,9.033-5.309V1.521A1.529,1.529,0,0,0,21.805,0Zm0,1.014H21.805a.5.5,0,0,1,.507.507V7.21a5.575,5.575,0,0,0-2.536-.618,1.521,1.521,0,1,0-3.043,0,1.486,1.486,0,0,0,.222.777,5.564,5.564,0,0,0-2.757,4.8H1.521a.5.5,0,0,1-.507-.507V1.521a.5.5,0,0,1,.507-.507m3.55,4.057A1.521,1.521,0,1,0,6.592,6.592,1.522,1.522,0,0,0,5.071,5.071m6.592,0a1.521,1.521,0,1,0,1.521,1.521,1.522,1.522,0,0,0-1.521-1.521m8.114,2.535a4.564,4.564,0,1,1-4.564,4.564,4.557,4.557,0,0,1,4.564-4.564",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M247.548,137.276a.756.756,0,0,0-.083.021.656.656,0,0,0-.516.464.663.663,0,0,0,.186.67l1.506,1.506-1.506,1.506a.671.671,0,1,0,.949.949l1.506-1.506,1.506,1.506a.671.671,0,1,0,.949-.949l-1.506-1.506,1.506-1.506a.661.661,0,0,0-.557-1.135.665.665,0,0,0-.392.186l-1.506,1.506-1.506-1.506a.663.663,0,0,0-.536-.206",
    transform: "translate(-229.813 -127.762)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.b897931f333d9521a1ac018e1ffa264c.svg";
export { ForwardRef as ReactComponent };